import React from "react";
import { Link2, Wand2, Share2, Scissors, Captions, Gauge, Clapperboard } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function HowItWorks() {
  const { t, lang, L } = useLang();

  const steps = [
    { icon: Link2, title: t("how_1_title"), desc: t("how_1_desc"), n: "01" },
    { icon: Wand2, title: t("how_2_title"), desc: t("how_2_desc"), n: "02" },
    { icon: Share2, title: t("how_3_title"), desc: t("how_3_desc"), n: "03" },
  ];

  const features = [
    {
      icon: Gauge,
      title:L("Viral Score", "Viral Score"),
      desc:L("Cada clip recibe un porcentaje de potencial viral para que publiques solo lo mejor.", "Every clip gets a viral potential percentage so you only post the best."),
    },
    {
      icon: Captions,
      title:L("Subtítulos automáticos", "Auto captions"),
      desc:L("Subtítulos con estilos virales, animados y sincronizados automáticamente.", "Animated, perfectly synced captions with viral styles."),
    },
    {
      icon: Scissors,
      title:L("Cortes inteligentes", "Smart cuts"),
      desc:L("Detecta silencios, partes aburridas y añade zooms y efectos automáticos.", "Detects silences, boring parts and adds auto zooms and effects."),
    },
    {
      icon: Clapperboard,
      title:L("AI Clip Factory", "AI Clip Factory"),
      desc:L("Genera múltiples clips de un mismo vídeo en un solo clic.", "Generate multiple clips from the same video in one click."),
    },
  ];

  return (
    <>
      <section id="how" className="py-20 sm:py-28">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight">{t("how_title")}</h2>
            <p className="mt-4 text-zinc-400 text-lg">{t("how_sub")}</p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            <div className="hidden md:block absolute top-9 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent" />
            {steps.map((s) => (
              <div key={s.n} className="text-center relative">
                <div className="mx-auto h-18 w-18 relative">
                  <div className="h-18 w-18 rounded-2xl bg-zinc-900 border border-white/10 flex items-center justify-center mx-auto relative z-10">
                    <s.icon className="h-7 w-7 text-yellow-400" />
                  </div>
                </div>
                <span className="mt-4 block text-xs font-bold tracking-widest text-yellow-400">{s.n}</span>
                <h3 className="mt-1 text-xl font-bold">{s.title}</h3>
                <p className="mt-2 text-zinc-400 text-sm max-w-xs mx-auto leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="features" className="py-20 sm:py-24 border-t border-white/5">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight">
              {L("Todo lo que necesitas para hacerte viral", "Everything you need to go viral")}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {features.map((f, i) => (
              <div
                key={i}
                className="flex gap-4 rounded-2xl border border-white/10 bg-zinc-900/50 p-6 hover:border-yellow-400/30 transition-colors"
              >
                <div className="h-12 w-12 shrink-0 rounded-xl bg-yellow-400/10 flex items-center justify-center">
                  <f.icon className="h-6 w-6 text-yellow-400" />
                </div>
                <div>
                  <h3 className="text-lg font-bold">{f.title}</h3>
                  <p className="mt-1.5 text-zinc-400 text-sm leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
